import BaseComponent from './BaseComponent.js'

export default class CozyDate extends BaseComponent {
  static get is() { return 'date' }

  get styles() {
    return `
      :host span {
        cursor: default;
        font-weight: bold;
        display: inline-flex;
        align-items: center;
        white-space: nowrap;
      }
      :host i {
        opacity: 0.7;
        font-weight: normal;
        margin-right: 0.1em;
      }
    `
  }

  get date() {
    const [dateStr] = this.params
    return new Date(dateStr)
  }

  updated() {
    const date = this.date
    if (isNaN(date.getTime())) {
      this.componentText = 'Invalid date'
      return
    }
    this.setComponentAttribute('title', this.params[0] || '')
    this.componentText = date.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })
  }
}
